import API, { getAuthOrigin } from "./api";

// New OTP-based registration endpoints
export const requestRegistrationOtp = (data) =>
  API.post("/request-otp", data).then((res) => res.data);

export const sendRegistrationOTP = (data) =>
  API.post("/send-registration-otp", data).then((res) => res.data);

export const verifyRegistrationOtp = (data) =>
  API.post("/verify-otp", data).then((res) => res.data);

export const verifyRegistrationOTP = (data) =>
  API.post("/verify-registration-otp", data).then((res) => res.data);

export const resendRegistrationOTP = (data) =>
  API.post("/resend-registration-otp", data).then((res) => res.data);

// OTP-based login
export const sendLoginOTP = (data) =>
  API.post("/send-login-otp", data).then((res) => res.data);

export const verifyLoginOTP = (data) =>
  API.post("/verify-login-otp", data).then((res) => res.data);

export const resendLoginOTP = (data) =>
  API.post("/resend-login-otp", data).then((res) => res.data);

export const completeRegistration = (data) =>
  API.post("/complete", data, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then((res) => res.data);

// Google OAuth login
export const googleLogin = (credential) =>
  API.post("/google-login", { credential }).then((res) => res.data);

// Get Google Client ID from backend
export const getGoogleClientId = () =>
  API.get("/google-client-id").then((res) => res.data);

const atozasJson = async (path, options = {}) => {
  const response = await fetch(`${getAuthOrigin()}${path}`, {
    credentials: "include",
    headers: { Accept: "application/json", ...(options.headers || {}) },
    ...options,
  });
  if (!response.ok) {
    return { enabled: false, authenticated: false };
  }
  return response.json();
};

export const getAtozasSession = () => atozasJson("/auth/atozas/me");

export const startGoogleLogin = (returnTo = "/") => {
  const url = new URL("/auth/google", `${getAuthOrigin()}/`);
  url.searchParams.set("returnTo", returnTo || "/");
  if (typeof window !== "undefined" && window.location?.origin) {
    // Tell the backend which frontend started the flow so the callback
    // redirects back here (e.g. localhost) instead of the default origin.
    url.searchParams.set("origin", window.location.origin);
  }
  window.location.assign(url.toString());
};

export const startAtozasLogin = (returnTo = "/", homepageKey) => {
  sessionStorage.removeItem("sso_logged_out");
  const url = new URL("/auth/atozas", `${getAuthOrigin()}/`);
  url.searchParams.set("returnTo", returnTo);
  if (homepageKey) {
    url.searchParams.set("homepage_key", homepageKey);
  }
  window.location.assign(url.toString());
};

export const logoutAtozasSession = async () => {
  try {
    const response = await fetch(`${getAuthOrigin()}/auth/logout`, {
      method: "POST",
      credentials: "include",
      headers: { Accept: "application/json", "Content-Type": "application/json" },
    });
    if (!response.ok) {
      return { success: true };
    }
    return response.json();
  } catch {
    // UnmaApp session logout must still succeed if the backend is unavailable.
    return { success: true };
  }
};
